module.exports = __webpack_public_path__ + "media/images/white-caret-a274274960d193e50c2b46292209c9a7.svg";